import {
  useBuscarTiendasAutoComplete,
  useBuscarTiendasDataGrid,
} from "../../Scripts/Services/facturacion-service.js";
import React, {useEffect,useState} from "react";

import {
  AutoComplete,
  SelectButton,
  Dropdown,
  addLocale,
  Button,
  Column,
  DataTable,
  Calendar,
  ProgressSpinner,
  FilterMatchMode,
  FilterOperator,
  InputNumber,
  locale,
  Message
} from 'primereact';
import {LOCALE_ES_GRID} from "../../../Commons/Scripts/Utils";

export const GridFacturacion = () => {
  addLocale("es", LOCALE_ES_GRID);
  const monedaPredeterminada = window.monedaPredeterminada;
  const [fechasGrid, setFechasGrid] = React.useState(null);
  // tabla
  const [tiendas, setTiendas] = React.useState([]);
  const [periodoGrid, setPeriodoGrid] = React.useState("mensual");
  const [filtros, setFiltros] = React.useState(null);
  const [cargandoData, setCargandoGrid] = React.useState(true);
  const [gridWhere, setGridWhere] = React.useState({
    where: {
      EsAscendente: false,
      EsOrdernable: true,
      OrderBy: "CantidadTotalVentas",
      IndiceDePagina: 0,
      esFecha: false,
      periodo: periodoGrid,
      TiendaNombresList: tiendas,
    },
  });
  const { data: tiendasGrid, error: errorTiendasGrid } = useBuscarTiendasDataGrid(gridWhere);
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [lazyState, setlazyState] = React.useState({
    first: 0,
    rows: 10,
    page: 0,
    sortField: "CantidadTotalVentas",
    sortOrder: -1,
    filters: {
      PromedioVenta: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
      },
      CantidadTotalVentas: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
      },
      PosiblesVentas: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
      },
      VentasCreditoPendientes: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
      },
      PromedioVentaCliente: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
      },
      PromedioVentaVendedor: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
      },
      CrecimientoVenta: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
      },
      PromedioMargenGanancia: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
      },
      TasaRelacionCotizacionFactura: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
      },
      Nombre: {
        value: null,
        matchMode: FilterMatchMode.IN,
      },
    },
  });
  const onPage = (event) => {
    const newWhere = {
      where: {
        ...gridWhere.where,
        fechaInicio: fechasGrid?.[0] ?? null,
        fechaFin: fechasGrid?.[1] ?? null,
        IndiceDePagina: event.page,
      },
    };
    setGridWhere(newWhere);
    setlazyState(event);
    setCargandoGrid(true);
  };
  const onSort = (event) => {
    const newWhere = {
      where: {
        ...gridWhere.where,        
        fechaInicio: fechasGrid?.[0] ?? null,
        fechaFin: fechasGrid?.[1] ?? null,
        EsAscendente: event.sortOrder == 1,
        OrderBy: event.sortField,
      },
    };
    setGridWhere(newWhere);
    setlazyState(event);
    setCargandoGrid(true);
  };
  const onFilter = (event) => {
    const filtros = event.filters;
    setlazyState(event);
    const CantidadTotalVentasFiltros =
      filtros.CantidadTotalVentas.constraints.map((e) => {
        var num = parseFloat(e.value);
        return {
          [num]: e.matchMode,
        };
      });
    const newWhere = {
      where: {
        ...gridWhere.where,
        fechaInicio: fechasGrid?.[0] ?? null,
        fechaFin: fechasGrid?.[1] ?? null,
        TiendaNombresList: filtros.Nombre.value,
        CantidadTotalVentasFiltros: CantidadTotalVentasFiltros,
        PromedioVentasFiltros: filtros.PromedioVenta.constraints.map((e) => ({
          [e.value]: e.matchMode,
        })),
        PosiblesVentasFiltros: filtros.PosiblesVentas.constraints.map((e) => ({
          [e.value]: e.matchMode,
        })),
        VentasCreditoPendientesFiltros: filtros.VentasCreditoPendientes.constraints.map(
          (e) => ({ [e.value]: e.matchMode })
        ),
        PromedioVentaClienteFiltros: filtros.PromedioVentaCliente.constraints.map(
          (e) => ({ [e.value]: e.matchMode })
        ),
        PromedioVentaVendedorFiltros: filtros.PromedioVentaVendedor.constraints.map(
          (e) => ({ [e.value]: e.matchMode })
        ),
        CrecimientoVentaFiltros: filtros.CrecimientoVenta.constraints.map((e) => ({
          [e.value]: e.matchMode,
        })),
        TasaRelacionCotizacionFacturaFiltros:
          filtros.TasaRelacionCotizacionFactura.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
        PromedioMargenGananciaFiltros: filtros.PromedioMargenGanancia.constraints.map(
          (e) => ({ [e.value]: e.matchMode })
        ),
      },
    };
    setGridWhere(newWhere);
    setCargandoGrid(true);
  };
  const borrarFiltros = () => {
    const newWhere = {
      where: {
        ...gridWhere.where,
        fechaInicio: fechasGrid?.[0] ?? null,
        fechaFin: fechasGrid?.[1] ?? null,
        TiendaNombresList: null,
        CantidadTotalVentasFiltros: null,
        PromedioVentasFiltros: null,
        PosiblesVentasFiltros: null,
        VentasCreditoPendientesFiltros: null,
        PromedioVentaClienteFiltros: null,
        PromedioVentaVendedorFiltros: null,
        CrecimientoVentaFiltros: null,
        TasaRelacionCotizacionFacturaFiltros: null,
        PromedioMargenGanancia: null,
      },
    };
    setGridWhere(newWhere);
    setCargandoGrid(true);
    initFiltros();
  };
  const initFiltros = () => {
    setFiltros({
      PromedioVenta: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
      },
      TasaRelacionCotizacionFactura: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
      },
      CantidadTotalVentas: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
      },
      PosiblesVentas: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
      },
      VentasCreditoPendientes: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
      },
      PromedioVentaCliente: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
      },
      PromedioVentaVendedor: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
      },
      CrecimientoVenta: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
      },
      PromedioMargenGanancia: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
      },
      Nombre: {
        value: null,
        matchMode: FilterMatchMode.IN,
      },
    });
  };
  const formatearTasa = (value) => {
    return `${value.toFixed(2)}%`;
  };
  const formatearCantidades = (value) => {
    if(value > 0) return value.toFixed(2);
    else return value;
  }; 
  const formatearMoneda = (value) => {
    return `${monedaPredeterminada} ${Citrus.Convert.toCurrencyNoSimbolo(
      value
    )}`;
  };
  const montoFiltroTemplate = (options) => {
    return (
      <InputNumber
        value={options.value}
        onChange={(e) => options.filterCallback(e.value, options.index)}
        prefix={monedaPredeterminada}
        locale="en-US" minFractionDigits={2}
      />
    );
  };
  const tasasFiltroTemplate = (options) => {
    return (
      <InputNumber
        value={options.value}
        onChange={(e) => options.filterCallback(e.value, options.index)}
        suffix="%"
      />
    );
  };
  const CantidadesFiltroTemplate = (options) => {
    return (
      <InputNumber
        value={options.value}
        onChange={(e) => options.filterCallback(e.value, options.index)}
      />
    );
  };
  const NombreFiltroTemplate = (options) => {
    return (
        <AutoComplete
          pt={{
            panel: { style: { width: "400px" } },
          }}
          onClick={(e) => autoCompleteRef.current.search(e, "", "dropdown")}
          ref={autoCompleteRef}
          emptyMessage="No hay resultados disponibles"
          showEmptyMessage="true"
          inputId="ac"
          value={options.value}
          multiple
          suggestions={dataFiltrada}
          completeMethod={buscarTiendas}
          placeholder="Buscar Tiendas"
          onChange={(e) => options.filterCallback(e.value)}
          style={{ width: "400px" }}
        />
    );
  };

  //multiLookup
  const autoCompleteRef = React.useRef(null);
  const [where, setWhere] = React.useState({ where: {} });
  const { data } = useBuscarTiendasAutoComplete(where);
  const [dataFiltrada, setDataFiltrada] = React.useState(null);
  const [cargando, setCargando] = React.useState(true);
  const buscarTiendas = (event) => {
    setWhere({ where: { Criterio: event.query, CantidadPorPagina: 1000 } });
  };

  //filtro periodos
  const [periodo, setPeriodo] = React.useState(1);
  const periodos = [
    { name: "Actual", value: 1 },
    { name: "Anterior", value: 2 },
    { name: "Otro", value: 3 },
  ];
  const [value, setValue] = React.useState(3);
  const [periodosPredifinidos, setPeriodosPredifinidos] = React.useState([]);
  const actual = [
    { name: "Hoy", value: 1 },
    { name: "Esta Semana", value: 2 },
    { name: "Este Mes", value: 3 },
    { name: "Este Trimestre", value: 4 },
    { name: "Este Año", value: 5 },
  ];
  const anterior = [
    { name: "Ayer", value: 6 },
    { name: "Semana Anterior", value: 7 },
    { name: "Mes Anterior", value: 8 },
    { name: "Trimestre Anterior", value: 9 },
    { name: "Año Anterior", value: 10 },
  ];
  function handleChange(value) {
    setValue(value);
    setCargandoGrid(true);
    let periodo;
    switch (value) {
      case 1:
        periodo = "diario";
        break;
      case 2:
        periodo = "semanal";
        break;
      case 3:
        periodo = "mensual";
        break;
      case 4:
        periodo = "trimestral";
        break;
      case 5:
        periodo = "anual";
        break;
      case 6:
        periodo = "ayer";
        break;
      case 7:
        periodo = "semana anterior";
        break;
      case 8:
        periodo = "mes anterior";
        break;
      case 9:
        periodo = "trimestre anterior";
        break;
      case 10:
        periodo = "ano anterior";
        break;
    }
    setPeriodoGrid(periodo);
    const newWhere = {
      where: {
        ...gridWhere.where,
        periodo: periodo,
        esFecha: false
      },
    };
    setGridWhere(newWhere);
  }
  const [dates, setDates] = React.useState(null);
  let today = new Date();
  const [verRangoDeFechas, setVerRangoDeFechas] = React.useState(false);

  function setFechas() {
    setValue(null)
    const fechasFormateadas = dates.map(date => formatDate(date));
    setFechasGrid(fechasFormateadas);
    const newWhere = {
      where: {
        ...gridWhere.where,
        fechaInicio: formatDate(dates[0]),
        fechaFin: formatDate(dates[1]),
        esFecha: true
      },
    };
    setGridWhere(newWhere);
    setCargandoGrid(true);
  }
  function formatDate(date) {
    var date = new Date(date);
    var day = date.getDate();
    var month = date.getMonth() + 1;
    var year = date.getFullYear();
    return day + "/" + month + "/" + year;
  }
  const header = () => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div className='p-component'>
          <Button
            type="button"
            icon="pi pi-filter-slash"
            label="Limpiar Filtros"
            outlined
            onClick={borrarFiltros}
            id="quitarFiltros"
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            flexDirection: "column",
            alignItems: "center",
            minWidth: "50%",
          }}
        >
          <div style={{ width: "40%", marginBottom: "5px" }}>
            <Dropdown
              value={periodo}
              onChange={(e) => setPeriodo(e.value)}
              options={periodos}
              optionLabel="name"
            />
          </div>

          {verRangoDeFechas ? (
            <div>
              <Calendar
                maxDate={today}
                placeholder="Rango de Fechas"
                dateFormat="dd/mm/yy"
                value={dates}
                selectionMode="range"
                locale="es"
                onChange={(e) => setDates(e.value)}
              />
            </div>
          ) : (
            <SelectButton
              value={value}
              onChange={(e) => handleChange(e.value)}
              optionLabel="name"
              options={periodosPredifinidos}
            />
          )}
        </div>
      </div>
    );
  };
  const matchModes = [
    { label: 'Menor o igual a', value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
    { label: 'Mayor o igual a', value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
];
  // useEffect
  React.useEffect(() => {
    locale('es');
    initFiltros();
}, []);
  React.useEffect(() => {
    if (data) {
      let _tiendasFiltradas = [];
      _tiendasFiltradas = data.Resultados.map((e) => {
        return e.text;
      });
      setDataFiltrada(_tiendasFiltradas);
    }
  }, [data]);
  React.useEffect(() => {
    if(tiendasGrid && !errorTiendasGrid) {
      setTotalRecords(tiendasGrid.total);
      setCargando(false);
      setCargandoGrid(false);
  } else if (tiendasGrid) {
      setTotalRecords(tiendasGrid.total);
      setCargando(false);
      setCargandoGrid(false);
  }
  }, [tiendasGrid]);
  React.useEffect(() => {
    if (dates) {
      if (dates[0] !== null && dates[1] !== null) {
        setFechas();
      }
    }
  }, [dates]);
  React.useEffect(() => {
    if (periodo == 1) {
      setPeriodosPredifinidos(actual);
      setVerRangoDeFechas(false);
    } else if (periodo == 2) {
      setPeriodosPredifinidos(anterior);
      setVerRangoDeFechas(false);
    } else {
      setVerRangoDeFechas(true);
    }
  }, [periodo]);
  React.useEffect(() => {
    setlazyState({
      ...lazyState,
      filters: filtros,
    });
  }, [filtros]);

  return (
    <div className='new-p-table'>
      {cargando ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ProgressSpinner />
        </div>
      ) : (
        <>
        <div>
        {errorTiendasGrid && (
          <Message
            severity="warn"
            text={errorTiendasGrid?.Mensaje}
            style={{ width: "100%", marginBottom: '10px' }}
          />
        )}
        </div>
        <DataTable
          showGridlines
          header={header}
          onFilter={onFilter}
          filters={lazyState.filters}
          value={tiendasGrid.tiendas}
          lazy
          first={lazyState.first}
          rows={25}
          loading={cargandoData}
          paginator
          totalRecords={totalRecords}
          onPage={onPage}
          onSort={onSort}
          sortField={lazyState.sortField}
          sortOrder={lazyState.sortOrder}
          tableStyle={{ minWidth: "50rem" }}
          stripedRows
          size="small"
          emptyMessage="No hay resultados disponibles."
          resizableColumns
          columnResizeMode="expand"
          pt={{
            paginator: { pageButton: 'p-component',nextPageButton: 'p-component', lastPageButton:'p-component', prevPageButton:'p-component', firstPageButton:'p-component' }
          }}
        >
          <Column
            field="IdSec"
            sortable
            header="Id"
            style={{ textAlign: "right" }}
          />
          <Column
            showFilterMatchModes={false}
            filter
            filterField="Nombre"
            filterElement={NombreFiltroTemplate}
            field="Nombre"
            sortable
            header="Tienda"
            pt={{
              filterMenuButton: { className: 'p-component' },
              filterButtonbar: { className:'test' },
            }}
          />
          <Column
            filter
            filterField="CantidadTotalVentas"
            filterElement={montoFiltroTemplate}
            dataType="numeric"
            field="CantidadTotalVentas"
            sortable
            header="Ventas"
            style={{ textAlign: "right" }}
            showFilterOperator={false}
            filterMatchModeOptions={matchModes}
            pt={{
              filterMenuButton: { className: 'p-component' }, 
              filterButtonbar: { className:'test' },
            }}
            filterPlaceholder="Filtrar por Cantidad de Ventas"
            body={(rowData) => formatearMoneda(rowData.CantidadTotalVentas)}
          />
          <Column
            filter
            filterField="Ganancias"
            filterElement={montoFiltroTemplate}
            dataType="numeric"
            field="Ganancias"
            sortable
            header="Ganancias"
            style={{ textAlign: "right" }}
            showFilterOperator={false}
            filterMatchModeOptions={matchModes}
            pt={{
              filterMenuButton: { className: 'p-component' }, 
              filterButtonbar: { className:'test' },
            }}
            filterPlaceholder="Filtrar por Cantidad de Ventas"
            body={(rowData) => formatearMoneda(rowData.Ganancias)}
          />
          <Column
            filter
            filterField="CrecimientoVenta"
            filterElement={tasasFiltroTemplate}
            field="CrecimientoVenta"
            sortable
            header="Tasa de Crecimiento de Ventas"
            style={{ textAlign: "right" }}
            dataType="numeric"
            body={(rowData) => formatearTasa(rowData.CrecimientoVenta)}
            showFilterOperator={false}
            filterMatchModeOptions={matchModes}
            pt={{
              filterMenuButton: { className: 'p-component' },
              filterButtonbar: { className:'test' },
            }}
          />
          <Column
            filter
            filterField="PromedioVenta"
            filterElement={montoFiltroTemplate}
            dataType="numeric"
            field="PromedioVenta"
            sortable
            header="Promedio de Ventas"
            style={{ textAlign: "right" }}
            body={(rowData) => formatearMoneda(rowData.PromedioVenta)}
            showFilterOperator={false}
            filterMatchModeOptions={matchModes}
            pt={{
              filterMenuButton: { className: 'p-component' },
              filterButtonbar: { className:'test' },
            }}
          />
          <Column
            filter
            filterField="PromedioVentaVendedor"
            filterElement={montoFiltroTemplate}
            dataType="numeric"
            field="PromedioVentaVendedor"
            sortable
            body={(rowData) => formatearMoneda(rowData.PromedioVentaVendedor)}
            header="Promedio de Venta por Vendedor"
            style={{ textAlign: "right" }}
            showFilterOperator={false}
            filterMatchModeOptions={matchModes}
            pt={{
              filterMenuButton: { className: 'p-component' },
              filterButtonbar: { className:'test' },
            }}
          />
          <Column
            filter
            filterField="PromedioVentaCliente"
            filterElement={montoFiltroTemplate}
            dataType="numeric"
            field="PromedioVentaCliente"
            sortable
            body={(rowData) => formatearMoneda(rowData.PromedioVentaCliente)}
            header="Promedio de Venta por Cliente"
            style={{ textAlign: "right" }}
            showFilterOperator={false}
            filterMatchModeOptions={matchModes}
            pt={{
              filterMenuButton: { className: 'p-component' },
              filterButtonbar: { className:'test' },
            }}
          />
          <Column
            filter
            filterField="VentasCreditoPendientes"
            filterElement={montoFiltroTemplate}
            dataType="numeric"
            field="VentasCreditoPendientes"
            sortable
            header="Ventas a Credito Pendientes"
            style={{ textAlign: "right" }}
            showFilterOperator={false}
            filterMatchModeOptions={matchModes}
            pt={{
              filterMenuButton: { className: 'p-component' },
              filterButtonbar: { className:'test' },
            }}
            body={(rowData) => formatearMoneda(rowData.VentasCreditoPendientes)}
          />
          <Column
            filter
            filterField="PromedioMargenGanancia"
            field="PromedioMargenGanancia"
            filterElement={tasasFiltroTemplate}
            sortable
            body={(rowData) => formatearTasa(rowData.PromedioMargenGanancia)}
            header="Promedio de Margen de Ganacias"
            style={{ textAlign: "right" }}
            showFilterOperator={false}
            filterMatchModeOptions={matchModes}
            pt={{
              filterMenuButton: { className: 'p-component' },
              filterButtonbar: { className:'test' },
            }}
          />
          <Column
            filter
            filterField="PosiblesVentas"
            filterElement={montoFiltroTemplate}
            dataType="numeric"
            field="PosiblesVentas"
            sortable
            header="Posibles Ventas"
            style={{ textAlign: "right" }}
            showFilterOperator={false}
            filterMatchModeOptions={matchModes}
            pt={{
              filterMenuButton: { className: 'p-component' },
              filterButtonbar: { className:'test' },
            }}
            body={(rowData) => formatearMoneda(rowData.PosiblesVentas)}
          />
          <Column
            filter
            filterField="TasaRelacionCotizacionFactura"
            field="TasaRelacionCotizacionFactura"
            filterElement={tasasFiltroTemplate}
            dataType="numeric"
            sortable
            body={(rowData) => formatearTasa(rowData.TasaRelacionCotizacionFactura)}
            header="Tasa de Relacion Cotizacion-Factura"
            style={{ textAlign: "right" }}
            showFilterOperator={false}
            filterMatchModeOptions={matchModes}
            pt={{
              filterMenuButton: { className: 'p-component' },
              filterButtonbar: { className:'test' },
            }}
          />
        </DataTable>
        </>
      )}
    </div>
  );
};